import React from 'react';

import { getFilePathExtension } from '@/globalFunction';

const getICONS = () => require('./Icon').ICONS;

export const FILE_ICONS = {
  xlsx: ({ width = '32', height = '32' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1052_35963)">
        <path
          d="M21 0H9C7.35 0 6.015 1.35 6.015 3L6 27C6 28.65 7.335 30 8.985 30H27C28.65 30 30 28.65 30 27V9L21 0ZM24 24H12V21H24V24ZM24 18H12V15H24V18ZM19.5 10.5V2.25L27.75 10.5H19.5Z"
          fill="#5081FF"
        />
      </g>
      <rect y="17.9766" width="25" height="10" rx="2" fill="#1C925B" />
      <path
        d="M3.24575 25.5026L4.92575 22.8546L3.30975 20.3506C3.24575 20.2466 3.30975 20.1266 3.44575 20.1266H4.61375C4.66975 20.1266 4.71775 20.1666 4.74175 20.1986L5.66175 21.6866H5.66975L6.60575 20.1986C6.62175 20.1666 6.67775 20.1266 6.73375 20.1266H7.90175C8.03775 20.1266 8.10975 20.2466 8.03775 20.3506L6.41375 22.8546L8.09375 25.5026C8.16575 25.6146 8.09375 25.7266 7.96575 25.7266H6.85375C6.80575 25.7266 6.74175 25.6946 6.71775 25.6546L5.66975 24.0386H5.65375L4.62975 25.6546C4.60575 25.6866 4.55775 25.7266 4.49375 25.7266H3.38175C3.24575 25.7266 3.17375 25.6066 3.24575 25.5026ZM8.882 25.5746V20.2786C8.882 20.1986 8.946 20.1266 9.034 20.1266H9.986C10.066 20.1266 10.138 20.1986 10.138 20.2786V24.5506H12.042C12.13 24.5506 12.194 24.6226 12.194 24.7026V25.5746C12.194 25.6546 12.13 25.7266 12.042 25.7266H9.034C8.946 25.7266 8.882 25.6546 8.882 25.5746ZM14.5521 25.8066C13.5121 25.8066 12.9361 25.3746 12.7521 25.1906C12.6881 25.1266 12.6641 25.0546 12.7201 24.9506L13.0881 24.3026C13.1521 24.1986 13.2801 24.1986 13.3601 24.2546C13.5841 24.4066 13.9921 24.6946 14.4961 24.6946C14.8161 24.6946 15.0481 24.4946 15.0481 24.2146C15.0481 23.8786 14.7521 23.6626 14.2241 23.4066C13.4481 23.0306 12.6721 22.5986 12.6721 21.6386C12.6721 20.8466 13.2881 20.0466 14.5201 20.0466C15.3521 20.0466 15.9921 20.4706 16.2321 20.6466C16.3281 20.7026 16.3121 20.8466 16.2801 20.9026L15.8721 21.5186C15.8161 21.6066 15.6801 21.6706 15.5201 21.5746C15.3361 21.4466 14.8641 21.1426 14.4401 21.1426C14.1041 21.1426 13.9521 21.3506 13.9521 21.5826C13.9521 21.8466 14.2641 22.0546 14.8241 22.3266C15.5281 22.6706 16.4401 23.0626 16.4401 24.1506C16.4401 24.9746 15.7281 25.8066 14.5521 25.8066ZM16.902 25.5026L18.582 22.8546L16.966 20.3506C16.902 20.2466 16.966 20.1266 17.102 20.1266H18.27C18.326 20.1266 18.374 20.1666 18.398 20.1986L19.318 21.6866H19.326L20.262 20.1986C20.278 20.1666 20.334 20.1266 20.39 20.1266H21.558C21.694 20.1266 21.766 20.2466 21.694 20.3506L20.07 22.8546L21.75 25.5026C21.822 25.6146 21.75 25.7266 21.622 25.7266H20.51C20.462 25.7266 20.398 25.6946 20.374 25.6546L19.326 24.0386H19.31L18.286 25.6546C18.262 25.6866 18.214 25.7266 18.15 25.7266H17.038C16.902 25.7266 16.83 25.6066 16.902 25.5026Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_1052_35963"
          x="6"
          y="0"
          width="26"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1052_35963"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1052_35963"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  xls: ({ width = '32', height = '32' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1052_35967)">
        <path
          d="M21 0H9C7.35 0 6.015 1.35 6.015 3L6 27C6 28.65 7.335 30 8.985 30H27C28.65 30 30 28.65 30 27V9L21 0ZM24 24H12V21H24V24ZM24 18H12V15H24V18ZM19.5 10.5V2.25L27.75 10.5H19.5Z"
          fill="#5081FF"
        />
      </g>
      <rect y="17.9766" width="25" height="10" rx="2" fill="#1C925B" />
      <path
        d="M5.82388 25.5026L7.50388 22.8546L5.88788 20.3506C5.82388 20.2466 5.88788 20.1266 6.02388 20.1266H7.19188C7.24788 20.1266 7.29588 20.1666 7.31988 20.1986L8.23988 21.6866H8.24788L9.18388 20.1986C9.19988 20.1666 9.25588 20.1266 9.31188 20.1266H10.4799C10.6159 20.1266 10.6879 20.2466 10.6159 20.3506L8.99188 22.8546L10.6719 25.5026C10.7439 25.6146 10.6719 25.7266 10.5439 25.7266H9.43188C9.38388 25.7266 9.31988 25.6946 9.29588 25.6546L8.24788 24.0386H8.23188L7.20788 25.6546C7.18388 25.6866 7.13588 25.7266 7.07188 25.7266H5.95988C5.82388 25.7266 5.75188 25.6066 5.82388 25.5026ZM11.4601 25.5746V20.2786C11.4601 20.1986 11.5241 20.1266 11.6121 20.1266H12.5641C12.6441 20.1266 12.7161 20.1986 12.7161 20.2786V24.5506H14.6201C14.7081 24.5506 14.7721 24.6226 14.7721 24.7026V25.5746C14.7721 25.6546 14.7081 25.7266 14.6201 25.7266H11.6121C11.5241 25.7266 11.4601 25.6546 11.4601 25.5746ZM17.1303 25.8066C16.0903 25.8066 15.5143 25.3746 15.3303 25.1906C15.2663 25.1266 15.2423 25.0546 15.2983 24.9506L15.6663 24.3026C15.7303 24.1986 15.8583 24.1986 15.9383 24.2546C16.1623 24.4066 16.5703 24.6946 17.0743 24.6946C17.3943 24.6946 17.6263 24.4946 17.6263 24.2146C17.6263 23.8786 17.3303 23.6626 16.8023 23.4066C16.0263 23.0306 15.2503 22.5986 15.2503 21.6386C15.2503 20.8466 15.8663 20.0466 17.0983 20.0466C17.9303 20.0466 18.5703 20.4706 18.8103 20.6466C18.9062 20.7026 18.8903 20.8466 18.8583 20.9026L18.4503 21.5186C18.3943 21.6066 18.2583 21.6706 18.0983 21.5746C17.9143 21.4466 17.4423 21.1426 17.0182 21.1426C16.6823 21.1426 16.5303 21.3506 16.5303 21.5826C16.5303 21.8466 16.8423 22.0546 17.4023 22.3266C18.1063 22.6706 19.0182 23.0626 19.0182 24.1506C19.0182 24.9746 18.3063 25.8066 17.1303 25.8066Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_1052_35967"
          x="6"
          y="0"
          width="26"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1052_35967"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1052_35967"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  csv: ({ width = '32', height = '32' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1052_35971)">
        <path
          d="M21 0H9C7.35 0 6.015 1.35 6.015 3L6 27C6 28.65 7.335 30 8.985 30H27C28.65 30 30 28.65 30 27V9L21 0ZM24 24H12V21H24V24ZM24 18H12V15H24V18ZM19.5 10.5V2.25L27.75 10.5H19.5Z"
          fill="#5081FF"
        />
      </g>
      <rect y="17.9766" width="25" height="10" rx="2" fill="#1C925B" />
      <path
        d="M5.25731 22.9346C5.25731 21.3346 6.54531 20.0466 8.14531 20.0466C8.94531 20.0466 9.53731 20.2946 10.0813 20.7906C10.1533 20.8546 10.1533 20.9506 10.0893 21.0146L9.46531 21.6626C9.40931 21.7186 9.32131 21.7186 9.26531 21.6626C8.93731 21.3746 8.57731 21.2546 8.18531 21.2546C7.28131 21.2546 6.61731 22.0066 6.61731 22.9026C6.61731 23.7906 7.28931 24.5266 8.19331 24.5266C8.63331 24.5266 8.97731 24.3906 9.26531 24.1426C9.32131 24.0946 9.42531 24.0946 9.47331 24.1506L10.0973 24.8146C10.1533 24.8706 10.1453 24.9746 10.0893 25.0306C9.54531 25.5586 8.85731 25.8066 8.14531 25.8066C6.54531 25.8066 5.25731 24.5346 5.25731 22.9346ZM12.5521 25.8066C11.5121 25.8066 10.9361 25.3746 10.7521 25.1906C10.6881 25.1266 10.6641 25.0546 10.7201 24.9506L11.0881 24.3026C11.1521 24.1986 11.2801 24.1986 11.3601 24.2546C11.5841 24.4066 11.9921 24.6946 12.4961 24.6946C12.8161 24.6946 13.0481 24.4946 13.0481 24.2146C13.0481 23.8786 12.7521 23.6626 12.2241 23.4066C11.4481 23.0306 10.6721 22.5986 10.6721 21.6386C10.6721 20.8466 11.2881 20.0466 12.5201 20.0466C13.3521 20.0466 13.9921 20.4706 14.2321 20.6466C14.3281 20.7026 14.3121 20.8466 14.2801 20.9026L13.8721 21.5186C13.8161 21.6066 13.6801 21.6706 13.5201 21.5746C13.3361 21.4466 12.8641 21.1426 12.4401 21.1426C12.1041 21.1426 11.9521 21.3506 11.9521 21.5826C11.9521 21.8466 12.2641 22.0546 12.8241 22.3266C13.5281 22.6706 14.4401 23.0626 14.4401 24.1506C14.4401 24.9746 13.7281 25.8066 12.5521 25.8066ZM17.4071 23.1346L18.7271 20.2146C18.7431 20.1746 18.7991 20.1266 18.8631 20.1266H19.9271C20.0471 20.1266 20.1111 20.2306 20.0631 20.3346L17.5511 25.7186C17.5271 25.7666 17.4791 25.8066 17.4151 25.8066H17.3351C17.2711 25.8066 17.2231 25.7666 17.1991 25.7186L14.7031 20.3346C14.6551 20.2306 14.7191 20.1266 14.8391 20.1266H15.9031C15.9671 20.1266 16.0231 20.1746 16.0391 20.2146L17.3591 23.1346H17.4071Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_1052_35971"
          x="6"
          y="0"
          width="26"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1052_35971"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1052_35971"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  pdf: ({ width = '32', height = '32' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1052_35975)">
        <path
          d="M21 0H9C7.35 0 6.015 1.35 6.015 3L6 27C6 28.65 7.335 30 8.985 30H27C28.65 30 30 28.65 30 27V9L21 0ZM24 24H12V21H24V24ZM24 18H12V15H24V18ZM19.5 10.5V2.25L27.75 10.5H19.5Z"
          fill="#5081FF"
        />
      </g>
      <rect y="17.9766" width="25" height="10" rx="2" fill="#EF4836" />
      <path
        d="M5.63981 25.5746V20.2786C5.63981 20.1986 5.70381 20.1266 5.79181 20.1266H7.71981C8.77581 20.1266 9.51181 20.9266 9.51181 21.8946C9.51181 22.8866 8.77581 23.6946 7.72781 23.6946H6.88781V25.5746C6.88781 25.6546 6.81581 25.7266 6.73581 25.7266H5.79181C5.70381 25.7266 5.63981 25.6546 5.63981 25.5746ZM6.88781 22.5266H7.69581C8.03981 22.5266 8.27981 22.2546 8.27981 21.8946C8.27981 21.5586 8.03981 21.3026 7.69581 21.3026H6.88781V22.5266ZM10.3195 25.5746V20.2786C10.3195 20.1986 10.3835 20.1266 10.4635 20.1266H12.4155C13.9595 20.1266 15.2235 21.3826 15.2235 22.9186C15.2235 24.4706 13.9595 25.7266 12.4155 25.7266H10.4635C10.3835 25.7266 10.3195 25.6546 10.3195 25.5746ZM11.5675 24.5426H12.4075C13.3115 24.5426 13.8955 23.8306 13.8955 22.9186C13.8955 22.0146 13.3115 21.3026 12.4075 21.3026H11.5675V24.5426ZM16.1789 25.5746V20.2786C16.1789 20.1986 16.2429 20.1266 16.3309 20.1266H19.6429C19.7309 20.1266 19.7949 20.1986 19.7949 20.2786V21.1506C19.7949 21.2306 19.7309 21.3026 19.6429 21.3026H17.4269V22.4546H19.2509C19.3309 22.4546 19.4029 22.5266 19.4029 22.6066V23.4786C19.4029 23.5586 19.3309 23.6306 19.2509 23.6306H17.4269V25.5746C17.4269 25.6546 17.3549 25.7266 17.2749 25.7266H16.3309C16.2429 25.7266 16.1789 25.6546 16.1789 25.5746Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_1052_35975"
          x="6"
          y="0"
          width="26"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1052_35975"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1052_35975"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  jpg: ({ width = '32', height = '32' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1052_35995)">
        <path
          d="M21 0H9C7.35 0 6.015 1.35 6.015 3L6 27C6 28.65 7.335 30 8.985 30H27C28.65 30 30 28.65 30 27V9L21 0ZM24 24H12V21H24V24ZM24 18H12V15H24V18ZM19.5 10.5V2.25L27.75 10.5H19.5Z"
          fill="#5081FF"
        />
      </g>
      <rect y="17.9766" width="25" height="10" rx="2" fill="#EF4836" />
      <path
        d="M5.59544 25.2226C5.55544 25.1586 5.56344 25.0786 5.61144 25.0226L6.15544 24.4866C6.21944 24.4306 6.30744 24.4226 6.37144 24.4866C6.46744 24.5826 6.59544 24.6546 6.77944 24.6546C7.00344 24.6546 7.25144 24.5666 7.25144 24.1266V20.2786C7.25144 20.1986 7.31544 20.1266 7.40344 20.1266H8.37944C8.46744 20.1266 8.53144 20.1986 8.53144 20.2786V24.1346C8.53144 25.2466 7.74744 25.8066 6.88344 25.8066C6.11544 25.8066 5.73144 25.3906 5.59544 25.2226ZM9.757 25.5746V20.2786C9.757 20.1986 9.821 20.1266 9.909 20.1266H11.837C12.893 20.1266 13.629 20.9266 13.629 21.8946C13.629 22.8866 12.893 23.6946 11.845 23.6946H11.005V25.5746C11.005 25.6546 10.933 25.7266 10.853 25.7266H9.909C9.821 25.7266 9.757 25.6546 9.757 25.5746ZM11.005 22.5266H11.813C12.157 22.5266 12.397 22.2546 12.397 21.8946C12.397 21.5586 12.157 21.3026 11.813 21.3026H11.005V22.5266ZM14.1167 22.9346C14.1167 21.3346 15.3967 20.0546 16.9887 20.0546C17.6607 20.0546 18.3967 20.3346 18.9407 20.8066C19.0127 20.8626 19.0207 20.9586 18.9567 21.0226L18.3247 21.6946C18.2607 21.7506 18.1727 21.7506 18.1087 21.7026C17.8047 21.4226 17.4527 21.3186 17.0607 21.3186C16.1887 21.3186 15.4847 22.0546 15.4847 22.9346C15.4847 23.8066 16.1967 24.5266 17.0687 24.5266C17.3007 24.5266 17.5407 24.4946 17.7807 24.3986V23.9346H17.2767C17.1887 23.9346 17.1247 23.8706 17.1247 23.7906V22.9986C17.1247 22.9106 17.1887 22.8466 17.2767 22.8466H18.8847C18.9647 22.8466 19.0287 22.9186 19.0287 22.9986L19.0367 25.1506C19.0367 25.2226 19.0047 25.2546 18.9727 25.2786C18.9727 25.2786 18.1487 25.7986 16.9887 25.7986C15.3967 25.7986 14.1167 24.5346 14.1167 22.9346Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_1052_35995"
          x="6"
          y="0"
          width="26"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1052_35995"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1052_35995"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  jpeg: ({ width = '32', height = '32' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1052_35999)">
        <path
          d="M21 0H9C7.35 0 6.015 1.35 6.015 3L6 27C6 28.65 7.335 30 8.985 30H27C28.65 30 30 28.65 30 27V9L21 0ZM24 24H12V21H24V24ZM24 18H12V15H24V18ZM19.5 10.5V2.25L27.75 10.5H19.5Z"
          fill="#5081FF"
        />
      </g>
      <rect y="17.9766" width="25" height="10" rx="2" fill="#EF4836" />
      <path
        d="M3.32591 25.2226C3.28591 25.1586 3.29391 25.0786 3.34191 25.0226L3.88591 24.4866C3.94991 24.4306 4.03791 24.4226 4.10191 24.4866C4.19791 24.5826 4.32591 24.6546 4.50991 24.6546C4.73391 24.6546 4.98191 24.5666 4.98191 24.1266V20.2786C4.98191 20.1986 5.04591 20.1266 5.13391 20.1266H6.10991C6.19791 20.1266 6.26191 20.1986 6.26191 20.2786V24.1346C6.26191 25.2466 5.47791 25.8066 4.61391 25.8066C3.84591 25.8066 3.46191 25.3906 3.32591 25.2226ZM7.48747 25.5746V20.2786C7.48747 20.1986 7.55147 20.1266 7.63947 20.1266H9.56747C10.6235 20.1266 11.3595 20.9266 11.3595 21.8946C11.3595 22.8866 10.6235 23.6946 9.57547 23.6946H8.73547V25.5746C8.73547 25.6546 8.66347 25.7266 8.58347 25.7266H7.63947C7.55147 25.7266 7.48747 25.6546 7.48747 25.5746ZM8.73547 22.5266H9.54347C9.88747 22.5266 10.1275 22.2546 10.1275 21.8946C10.1275 21.5586 9.88747 21.3026 9.54347 21.3026H8.73547V22.5266ZM12.1672 25.5746V20.2786C12.1672 20.1986 12.2312 20.1266 12.3192 20.1266H15.6312C15.7192 20.1266 15.7832 20.1986 15.7832 20.2786V21.1506C15.7832 21.2306 15.7192 21.3026 15.6312 21.3026H13.4152V22.2946H15.2392C15.3192 22.2946 15.3912 22.3666 15.3912 22.4466V23.3186C15.3912 23.4066 15.3192 23.4706 15.2392 23.4706H13.4152V24.5506H15.6312C15.7192 24.5506 15.7832 24.6226 15.7832 24.7026V25.5746C15.7832 25.6546 15.7192 25.7266 15.6312 25.7266H12.3192C12.2312 25.7266 12.1672 25.6546 12.1672 25.5746ZM16.3862 22.9346C16.3862 21.3346 17.6662 20.0546 19.2582 20.0546C19.9302 20.0546 20.6662 20.3346 21.2102 20.8066C21.2822 20.8626 21.2902 20.9586 21.2262 21.0226L20.5942 21.6946C20.5302 21.7506 20.4422 21.7506 20.3782 21.7026C20.0742 21.4226 19.7222 21.3186 19.3302 21.3186C18.4582 21.3186 17.7542 22.0546 17.7542 22.9346C17.7542 23.8066 18.4662 24.5266 19.3382 24.5266C19.5702 24.5266 19.8102 24.4946 20.0502 24.3986V23.9346H19.5462C19.4582 23.9346 19.3942 23.8706 19.3942 23.7906V22.9986C19.3942 22.9106 19.4582 22.8466 19.5462 22.8466H21.1542C21.2342 22.8466 21.2982 22.9186 21.2982 22.9986L21.3062 25.1506C21.3062 25.2226 21.2742 25.2546 21.2422 25.2786C21.2422 25.2786 20.4182 25.7986 19.2582 25.7986C17.6662 25.7986 16.3862 24.5346 16.3862 22.9346Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_1052_35999"
          x="6"
          y="0"
          width="26"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1052_35999"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1052_35999"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  png: ({ width = '32', height = '32' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1052_36003)">
        <path
          d="M21 0H9C7.35 0 6.015 1.35 6.015 3L6 27C6 28.65 7.335 30 8.985 30H27C28.65 30 30 28.65 30 27V9L21 0ZM24 24H12V21H24V24ZM24 18H12V15H24V18ZM19.5 10.5V2.25L27.75 10.5H19.5Z"
          fill="#5081FF"
        />
      </g>
      <rect y="17.9766" width="25" height="10" rx="2" fill="#EF4836" />
      <path
        d="M4.92106 25.5746V20.2786C4.92106 20.1986 4.98506 20.1266 5.07306 20.1266H7.00106C8.05706 20.1266 8.79306 20.9266 8.79306 21.8946C8.79306 22.8866 8.05706 23.6946 7.00906 23.6946H6.16906V25.5746C6.16906 25.6546 6.09706 25.7266 6.01706 25.7266H5.07306C4.98506 25.7266 4.92106 25.6546 4.92106 25.5746ZM6.16906 22.5266H6.97706C7.32106 22.5266 7.56106 22.2546 7.56106 21.8946C7.56106 21.5586 7.32106 21.3026 6.97706 21.3026H6.16906V22.5266ZM9.60075 25.5746L9.59275 20.1906C9.59275 20.1106 9.66475 20.0466 9.74475 20.0466H9.86475C9.94475 20.0466 10.0008 20.1026 10.0648 20.1666L13.1368 23.1186H13.1448V20.2786C13.1448 20.1986 13.2088 20.1266 13.2968 20.1266H14.2568C14.3368 20.1266 14.4088 20.1986 14.4088 20.2786V25.6626C14.4088 25.7586 14.3368 25.8066 14.2568 25.8066H14.1768C14.0968 25.8066 14.0408 25.7826 13.9768 25.7186L10.8648 22.5906H10.8568V25.5746C10.8568 25.6546 10.7928 25.7266 10.7048 25.7266H9.75275C9.67275 25.7266 9.60075 25.6546 9.60075 25.5746ZM15.3511 22.9346C15.3511 21.3346 16.6311 20.0546 18.2231 20.0546C18.8951 20.0546 19.6311 20.3346 20.1751 20.8066C20.2471 20.8626 20.2551 20.9586 20.1911 21.0226L19.5591 21.6946C19.4951 21.7506 19.4071 21.7506 19.3431 21.7026C19.0391 21.4226 18.6871 21.3186 18.2951 21.3186C17.4231 21.3186 16.7191 22.0546 16.7191 22.9346C16.7191 23.8066 17.4311 24.5266 18.3031 24.5266C18.5351 24.5266 18.7751 24.4946 19.0151 24.3986V23.9346H18.5111C18.4231 23.9346 18.3591 23.8706 18.3591 23.7906V22.9986C18.3591 22.9106 18.4231 22.8466 18.5111 22.8466H20.1191C20.1991 22.8466 20.2631 22.9186 20.2631 22.9986L20.2711 25.1506C20.2711 25.2226 20.2391 25.2546 20.2071 25.2786C20.2071 25.2786 19.3831 25.7986 18.2231 25.7986C16.6311 25.7986 15.3511 24.5346 15.3511 22.9346Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_1052_36003"
          x="6"
          y="0"
          width="26"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1052_36003"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1052_36003"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  ppt: ({ width = '32', height = '32' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1052_35979)">
        <path
          d="M21 0H9C7.35 0 6.015 1.35 6.015 3L6 27C6 28.65 7.335 30 8.985 30H27C28.65 30 30 28.65 30 27V9L21 0ZM24 24H12V21H24V24ZM24 18H12V15H24V18ZM19.5 10.5V2.25L27.75 10.5H19.5Z"
          fill="#5081FF"
        />
      </g>
      <rect y="17.9766" width="25" height="10" rx="2" fill="#FBBC05" />
      <path
        d="M6.31559 25.5746V20.2786C6.31559 20.1986 6.37959 20.1266 6.46759 20.1266H8.39559C9.45159 20.1266 10.1876 20.9266 10.1876 21.8946C10.1876 22.8866 9.45159 23.6946 8.40359 23.6946H7.56359V25.5746C7.56359 25.6546 7.49159 25.7266 7.41159 25.7266H6.46759C6.37959 25.7266 6.31559 25.6546 6.31559 25.5746ZM7.56359 22.5266H8.37159C8.71559 22.5266 8.95559 22.2546 8.95559 21.8946C8.95559 21.5586 8.71559 21.3026 8.37159 21.3026H7.56359V22.5266ZM10.9953 25.5746V20.2786C10.9953 20.1986 11.0593 20.1266 11.1473 20.1266H13.0753C14.1313 20.1266 14.8673 20.9266 14.8673 21.8946C14.8673 22.8866 14.1313 23.6946 13.0833 23.6946H12.2433V25.5746C12.2433 25.6546 12.1713 25.7266 12.0913 25.7266H11.1473C11.0593 25.7266 10.9953 25.6546 10.9953 25.5746ZM12.2433 22.5266H13.0513C13.3953 22.5266 13.6353 22.2546 13.6353 21.8946C13.6353 21.5586 13.3953 21.3026 13.0513 21.3026H12.2433V22.5266ZM16.547 25.5746V21.3026H15.403C15.315 21.3026 15.251 21.2306 15.251 21.1506V20.2786C15.251 20.1986 15.315 20.1266 15.403 20.1266H18.955C19.043 20.1266 19.107 20.1986 19.107 20.2786V21.1506C19.107 21.2306 19.043 21.3026 18.955 21.3026H17.811V25.5746C17.811 25.6546 17.739 25.7266 17.659 25.7266H16.699C16.619 25.7266 16.547 25.6546 16.547 25.5746Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_1052_35979"
          x="6"
          y="0"
          width="26"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1052_35979"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1052_35979"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  pptx: ({ width = '32', height = '32' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1052_35991)">
        <path
          d="M21 0H9C7.35 0 6.015 1.35 6.015 3L6 27C6 28.65 7.335 30 8.985 30H27C28.65 30 30 28.65 30 27V9L21 0ZM24 24H12V21H24V24ZM24 18H12V15H24V18ZM19.5 10.5V2.25L27.75 10.5H19.5Z"
          fill="#5081FF"
        />
      </g>
      <rect y="17.9766" width="25" height="10" rx="2" fill="#FBBC05" />
      <path
        d="M3.73747 25.5746V20.2786C3.73747 20.1986 3.80147 20.1266 3.88947 20.1266H5.81747C6.87347 20.1266 7.60947 20.9266 7.60947 21.8946C7.60947 22.8866 6.87347 23.6946 5.82547 23.6946H4.98547V25.5746C4.98547 25.6546 4.91347 25.7266 4.83347 25.7266H3.88947C3.80147 25.7266 3.73747 25.6546 3.73747 25.5746ZM4.98547 22.5266H5.79347C6.13747 22.5266 6.37747 22.2546 6.37747 21.8946C6.37747 21.5586 6.13747 21.3026 5.79347 21.3026H4.98547V22.5266ZM8.41716 25.5746V20.2786C8.41716 20.1986 8.48116 20.1266 8.56916 20.1266H10.4972C11.5532 20.1266 12.2892 20.9266 12.2892 21.8946C12.2892 22.8866 11.5532 23.6946 10.5052 23.6946H9.66516V25.5746C9.66516 25.6546 9.59316 25.7266 9.51316 25.7266H8.56916C8.48116 25.7266 8.41716 25.6546 8.41716 25.5746ZM9.66516 22.5266H10.4732C10.8172 22.5266 11.0572 22.2546 11.0572 21.8946C11.0572 21.5586 10.8172 21.3026 10.4732 21.3026H9.66516V22.5266ZM13.9688 25.5746V21.3026H12.8248C12.7368 21.3026 12.6728 21.2306 12.6728 21.1506V20.2786C12.6728 20.1986 12.7368 20.1266 12.8248 20.1266H16.3768C16.4648 20.1266 16.5288 20.1986 16.5288 20.2786V21.1506C16.5288 21.2306 16.4648 21.3026 16.3768 21.3026H15.2328V25.5746C15.2328 25.6546 15.1608 25.7266 15.0808 25.7266H14.1208C14.0408 25.7266 13.9688 25.6546 13.9688 25.5746ZM16.8903 25.5026L18.5703 22.8546L16.9543 20.3506C16.8903 20.2466 16.9543 20.1266 17.0903 20.1266H18.2583C18.3143 20.1266 18.3623 20.1666 18.3863 20.1986L19.3063 21.6866H19.3143L20.2503 20.1986C20.2663 20.1666 20.3223 20.1266 20.3783 20.1266H21.5463C21.6823 20.1266 21.7543 20.2466 21.6823 20.3506L20.0583 22.8546L21.7383 25.5026C21.8103 25.6146 21.7383 25.7266 21.6103 25.7266H20.4983C20.4503 25.7266 20.3863 25.6946 20.3623 25.6546L19.3143 24.0386H19.2983L18.2743 25.6546C18.2503 25.6866 18.2023 25.7266 18.1383 25.7266H17.0263C16.8903 25.7266 16.8183 25.6066 16.8903 25.5026Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_1052_35991"
          x="6"
          y="0"
          width="26"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1052_35991"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1052_35991"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  doc: ({ width = '32', height = '32' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1052_35983)">
        <path
          d="M21 0H9C7.35 0 6.015 1.35 6.015 3L6 27C6 28.65 7.335 30 8.985 30H27C28.65 30 30 28.65 30 27V9L21 0ZM24 24H12V21H24V24ZM24 18H12V15H24V18ZM19.5 10.5V2.25L27.75 10.5H19.5Z"
          fill="#5081FF"
        />
      </g>
      <rect y="17.9766" width="25" height="10" rx="2" fill="#EEEEEE" />
      <path
        d="M4.29997 25.5746V20.2786C4.29997 20.1986 4.36397 20.1266 4.44397 20.1266H6.39597C7.93997 20.1266 9.20397 21.3826 9.20397 22.9186C9.20397 24.4706 7.93997 25.7266 6.39597 25.7266H4.44397C4.36397 25.7266 4.29997 25.6546 4.29997 25.5746ZM5.54797 24.5426H6.38797C7.29197 24.5426 7.87597 23.8306 7.87597 22.9186C7.87597 22.0146 7.29197 21.3026 6.38797 21.3026H5.54797V24.5426ZM9.83934 22.9346C9.83934 21.3346 11.1113 20.0466 12.7113 20.0466C14.3113 20.0466 15.5913 21.3346 15.5913 22.9346C15.5913 24.5346 14.3113 25.8066 12.7113 25.8066C11.1113 25.8066 9.83934 24.5346 9.83934 22.9346ZM11.1193 22.9346C11.1193 23.8066 11.8393 24.5266 12.7113 24.5266C13.5913 24.5266 14.3113 23.8066 14.3113 22.9346C14.3113 22.0546 13.5913 21.3266 12.7113 21.3266C11.8393 21.3266 11.1193 22.0546 11.1193 22.9346ZM16.2143 22.9346C16.2143 21.3346 17.5023 20.0466 19.1023 20.0466C19.9023 20.0466 20.4943 20.2946 21.0383 20.7906C21.1103 20.8546 21.1103 20.9506 21.0463 21.0146L20.4223 21.6626C20.3663 21.7186 20.2783 21.7186 20.2223 21.6626C19.8943 21.3746 19.5343 21.2546 19.1423 21.2546C18.2383 21.2546 17.5743 22.0066 17.5743 22.9026C17.5743 23.7906 18.2463 24.5266 19.1503 24.5266C19.5903 24.5266 19.9343 24.3906 20.2223 24.1426C20.2783 24.0946 20.3823 24.0946 20.4303 24.1506L21.0543 24.8146C21.1103 24.8706 21.1023 24.9746 21.0463 25.0306C20.5023 25.5586 19.8143 25.8066 19.1023 25.8066C17.5023 25.8066 16.2143 24.5346 16.2143 22.9346Z"
        fill="#5081FF"
      />
      <defs>
        <filter
          id="filter0_d_1052_35983"
          x="6"
          y="0"
          width="26"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1052_35983"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1052_35983"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  docx: ({ width = '32', height = '32' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1052_35987)">
        <path
          d="M21 0H9C7.35 0 6.015 1.35 6.015 3L6 27C6 28.65 7.335 30 8.985 30H27C28.65 30 30 28.65 30 27V9L21 0ZM24 24H12V21H24V24ZM24 18H12V15H24V18ZM19.5 10.5V2.25L27.75 10.5H19.5Z"
          fill="#5081FF"
        />
      </g>
      <rect y="17.9766" width="25" height="10" rx="2" fill="#EEEEEE" />
      <path
        d="M1.72184 25.5746V20.2786C1.72184 20.1986 1.78584 20.1266 1.86584 20.1266H3.81784C5.36184 20.1266 6.62584 21.3826 6.62584 22.9186C6.62584 24.4706 5.36184 25.7266 3.81784 25.7266H1.86584C1.78584 25.7266 1.72184 25.6546 1.72184 25.5746ZM2.96984 24.5426H3.80984C4.71384 24.5426 5.29784 23.8306 5.29784 22.9186C5.29784 22.0146 4.71384 21.3026 3.80984 21.3026H2.96984V24.5426ZM7.26122 22.9346C7.26122 21.3346 8.53322 20.0466 10.1332 20.0466C11.7332 20.0466 13.0132 21.3346 13.0132 22.9346C13.0132 24.5346 11.7332 25.8066 10.1332 25.8066C8.53322 25.8066 7.26122 24.5346 7.26122 22.9346ZM8.54122 22.9346C8.54122 23.8066 9.26122 24.5266 10.1332 24.5266C11.0132 24.5266 11.7332 23.8066 11.7332 22.9346C11.7332 22.0546 11.0132 21.3266 10.1332 21.3266C9.26122 21.3266 8.54122 22.0546 8.54122 22.9346ZM13.6362 22.9346C13.6362 21.3346 14.9242 20.0466 16.5242 20.0466C17.3242 20.0466 17.9162 20.2946 18.4602 20.7906C18.5322 20.8546 18.5322 20.9506 18.4682 21.0146L17.8442 21.6626C17.7882 21.7186 17.7002 21.7186 17.6442 21.6626C17.3162 21.3746 16.9562 21.2546 16.5642 21.2546C15.6602 21.2546 14.9962 22.0066 14.9962 22.9026C14.9962 23.7906 15.6682 24.5266 16.5722 24.5266C17.0122 24.5266 17.3562 24.3906 17.6442 24.1426C17.7002 24.0946 17.8042 24.0946 17.8522 24.1506L18.4762 24.8146C18.5322 24.8706 18.5242 24.9746 18.4682 25.0306C17.9242 25.5586 17.2362 25.8066 16.5242 25.8066C14.9242 25.8066 13.6362 24.5346 13.6362 22.9346ZM18.9059 25.5026L20.5859 22.8546L18.9699 20.3506C18.9059 20.2466 18.9699 20.1266 19.1059 20.1266H20.2739C20.3299 20.1266 20.3779 20.1666 20.4019 20.1986L21.3219 21.6866H21.3299L22.2659 20.1986C22.2819 20.1666 22.3379 20.1266 22.3939 20.1266H23.5619C23.6979 20.1266 23.7699 20.2466 23.6979 20.3506L22.0739 22.8546L23.7539 25.5026C23.8259 25.6146 23.7539 25.7266 23.6259 25.7266H22.5139C22.4659 25.7266 22.4019 25.6946 22.3779 25.6546L21.3299 24.0386H21.3139L20.2899 25.6546C20.2659 25.6866 20.2179 25.7266 20.1539 25.7266H19.0419C18.9059 25.7266 18.8339 25.6066 18.9059 25.5026Z"
        fill="#5081FF"
      />
      <defs>
        <filter
          id="filter0_d_1052_35987"
          x="6"
          y="0"
          width="26"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1052_35987"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1052_35987"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  zip: ({ width = '32', height = '32' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1052_36007)">
        <path
          d="M21 0H9C7.35 0 6.015 1.35 6.015 3L6 27C6 28.65 7.335 30 8.985 30H27C28.65 30 30 28.65 30 27V9L21 0ZM24 24H12V21H24V24ZM24 18H12V15H24V18ZM19.5 10.5V2.25L27.75 10.5H19.5Z"
          fill="#5081FF"
        />
      </g>
      <rect y="17.9766" width="25" height="10" rx="2" fill="#EEEEEE" />
      <path
        d="M6.91056 25.5746V25.5186C6.91056 25.4466 6.91856 25.3986 6.95856 25.3266L9.03856 21.3186V21.3026H7.29456C7.21456 21.3026 7.14256 21.2306 7.14256 21.1506V20.2786C7.14256 20.1986 7.21456 20.1266 7.29456 20.1266H10.6946C10.7746 20.1266 10.8466 20.1826 10.8466 20.2626V20.3266C10.8466 20.3746 10.8386 20.3986 10.7986 20.4786L8.79056 24.5346V24.5506H10.5346C10.6226 24.5506 10.6866 24.6226 10.6866 24.7026V25.5746C10.6866 25.6546 10.6226 25.7266 10.5346 25.7266H7.06256C6.98256 25.7266 6.91056 25.6546 6.91056 25.5746ZM11.6945 25.5746V20.2786C11.6945 20.1986 11.7665 20.1266 11.8465 20.1266H12.8065C12.8865 20.1266 12.9585 20.1986 12.9585 20.2786V25.5746C12.9585 25.6546 12.8865 25.7266 12.8065 25.7266H11.8465C11.7665 25.7266 11.6945 25.6546 11.6945 25.5746ZM14.2258 25.5746V20.2786C14.2258 20.1986 14.2898 20.1266 14.3778 20.1266H16.3058C17.3618 20.1266 18.0978 20.9266 18.0978 21.8946C18.0978 22.8866 17.3618 23.6946 16.3138 23.6946H15.4738V25.5746C15.4738 25.6546 15.4018 25.7266 15.3218 25.7266H14.3778C14.2898 25.7266 14.2258 25.6546 14.2258 25.5746ZM15.4738 22.5266H16.2818C16.6258 22.5266 16.8658 22.2546 16.8658 21.8946C16.8658 21.5586 16.6258 21.3026 16.2818 21.3026H15.4738V22.5266Z"
        fill="#626262"
      />
      <defs>
        <filter
          id="filter0_d_1052_36007"
          x="6"
          y="0"
          width="26"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1052_36007"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1052_36007"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  rar: ({ width = '32', height = '32' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1052_36011)">
        <path
          d="M21 0H9C7.35 0 6.015 1.35 6.015 3L6 27C6 28.65 7.335 30 8.985 30H27C28.65 30 30 28.65 30 27V9L21 0ZM24 24H12V21H24V24ZM24 18H12V15H24V18ZM19.5 10.5V2.25L27.75 10.5H19.5Z"
          fill="#5081FF"
        />
      </g>
      <rect y="17.9766" width="25" height="10" rx="2" fill="#EEEEEE" />
      <path
        d="M5.15544 25.5746V20.2786C5.15544 20.1986 5.21944 20.1266 5.30744 20.1266H7.69944C8.71544 20.1266 9.44344 20.9026 9.44344 21.8546C9.44344 22.5906 9.00344 23.1826 8.25944 23.4626L9.35544 25.4946C9.41144 25.5986 9.35544 25.7266 9.21944 25.7266H8.15544C8.09144 25.7266 8.04344 25.6866 8.02744 25.6546L6.96344 23.5346H6.41144V25.5746C6.41144 25.6546 6.33944 25.7266 6.25944 25.7266H5.30744C5.21944 25.7266 5.15544 25.6546 5.15544 25.5746ZM6.41144 22.5186H7.59544C7.92344 22.5186 8.20344 22.2546 8.20344 21.8786C8.20344 21.5026 7.92344 21.2706 7.59544 21.2706H6.41144V22.5186ZM9.95631 25.7266C9.83631 25.7266 9.77231 25.6226 9.82031 25.5186L12.3243 20.1346C12.3483 20.0866 12.4043 20.0466 12.4603 20.0466H12.5403C12.5963 20.0466 12.6523 20.0866 12.6763 20.1346L15.1803 25.5186C15.2283 25.6226 15.1643 25.7266 15.0443 25.7266H14.1563C14.0123 25.7266 13.9483 25.6786 13.8763 25.5266L13.5883 24.8946H11.4123L11.1243 25.5346C11.0843 25.6306 10.9963 25.7266 10.8363 25.7266H9.95631ZM11.8923 23.8066H13.1083L12.5003 22.4866H12.4923L11.8923 23.8066ZM15.8117 25.5746V20.2786C15.8117 20.1986 15.8757 20.1266 15.9637 20.1266H18.3557C19.3717 20.1266 20.0997 20.9026 20.0997 21.8546C20.0997 22.5906 19.6597 23.1826 18.9157 23.4626L20.0117 25.4946C20.0677 25.5986 20.0117 25.7266 19.8757 25.7266H18.8117C18.7477 25.7266 18.6997 25.6866 18.6837 25.6546L17.6197 23.5346H17.0677V25.5746C17.0677 25.6546 16.9957 25.7266 16.9157 25.7266H15.9637C15.8757 25.7266 15.8117 25.6546 15.8117 25.5746ZM17.0677 22.5186H18.2517C18.5797 22.5186 18.8597 22.2546 18.8597 21.8786C18.8597 21.5026 18.5797 21.2706 18.2517 21.2706H17.0677V22.5186Z"
        fill="#626262"
      />
      <defs>
        <filter
          id="filter0_d_1052_36011"
          x="6"
          y="0"
          width="26"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1052_36011"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1052_36011"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  dat: ({ width = '32', height = '32' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1052_36015)">
        <path
          d="M21 0H9C7.35 0 6.015 1.35 6.015 3L6 27C6 28.65 7.335 30 8.985 30H27C28.65 30 30 28.65 30 27V9L21 0ZM24 24H12V21H24V24ZM24 18H12V15H24V18ZM19.5 10.5V2.25L27.75 10.5H19.5Z"
          fill="#5081FF"
        />
      </g>
      <rect y="17.9766" width="25" height="10" rx="2" fill="#EEEEEE" />
      <path
        d="M5.64372 25.5746V20.2786C5.64372 20.1986 5.70772 20.1266 5.78772 20.1266H7.73972C9.28372 20.1266 10.5477 21.3826 10.5477 22.9186C10.5477 24.4706 9.28372 25.7266 7.73972 25.7266H5.78772C5.70772 25.7266 5.64372 25.6546 5.64372 25.5746ZM6.89172 24.5426H7.73172C8.63572 24.5426 9.21972 23.8306 9.21972 22.9186C9.21972 22.0146 8.63572 21.3026 7.73172 21.3026H6.89172V24.5426ZM10.8587 25.7266C10.7387 25.7266 10.6747 25.6226 10.7227 25.5186L13.2267 20.1346C13.2507 20.0866 13.3067 20.0466 13.3627 20.0466H13.4427C13.4987 20.0466 13.5547 20.0866 13.5787 20.1346L16.0827 25.5186C16.1307 25.6226 16.0667 25.7266 15.9467 25.7266H15.0587C14.9147 25.7266 14.8507 25.6786 14.7787 25.5266L14.4907 24.8946H12.3147L12.0267 25.5346C11.9867 25.6306 11.8987 25.7266 11.7387 25.7266H10.8587ZM12.7947 23.8066H14.0107L13.4027 22.4866H13.3947L12.7947 23.8066ZM17.2188 25.5746V21.3026H16.0748C15.9868 21.3026 15.9228 21.2306 15.9228 21.1506V20.2786C15.9228 20.1986 15.9868 20.1266 16.0748 20.1266H19.6268C19.7148 20.1266 19.7788 20.1986 19.7788 20.2786V21.1506C19.7788 21.2306 19.7148 21.3026 19.6268 21.3026H18.4828V25.5746C18.4828 25.6546 18.4108 25.7266 18.3308 25.7266H17.3708C17.2908 25.7266 17.2188 25.6546 17.2188 25.5746Z"
        fill="#626262"
      />
      <defs>
        <filter
          id="filter0_d_1052_36015"
          x="6"
          y="0"
          width="26"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1052_36015"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1052_36015"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  unsupported: (
    { width = '21', height = '22' } = { width: '21', height: '22' }
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 22"
      fill="none"
    >
      <g filter="url(#filter0_d_362_16223)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 0H13L19 6V13.2929L18 14.2929L16.3536 12.6464L16 12.2929L15.6464 12.6464L14 14.2929L12.3536 12.6464L12 12.2929L11.6464 12.6464L10 14.2929L8.35355 12.6464L8 12.2929L7.64645 12.6464L6 14.2929L4.35355 12.6464L4 12.2929L3.64645 12.6464L3.00294 13.2899L3.01 2C3.01 0.9 3.9 0 5 0ZM3.00206 14.705L3 18C3 19.1 3.89 20 4.99 20H17C18.1 20 19 19.1 19 18V14.7071L18.3536 15.3536L18 15.7071L17.6464 15.3536L16 13.7071L14.3536 15.3536L14 15.7071L13.6464 15.3536L12 13.7071L10.3536 15.3536L10 15.7071L9.64645 15.3536L8 13.7071L6.35355 15.3536L6 15.7071L5.64645 15.3536L4 13.7071L3.00206 14.705ZM12 1.5V7H17.5L12 1.5Z"
          fill="#C4C4C4"
        />
      </g>
      <rect y="10" width="8" height="8" rx="4" fill="#D34A46" />
      <path
        d="M2.4 16L2 15.6L3.6 14L2 12.4L2.4 12L4 13.6L5.6 12L6 12.4L4.4 14L6 15.6L5.6 16L4 14.4L2.4 16Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_362_16223"
          x="3"
          y="0"
          width="18"
          height="22"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254902 0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_362_16223"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_362_16223"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
};

type FileIconParams = {
  width?: string;
  height?: string;
};

export const getFileIcon = (fileName: string, params: FileIconParams = {}) => {
  const ext = fileName ? getFilePathExtension(fileName).toLowerCase() : null;

  return FILE_ICONS[ext] ? FILE_ICONS[ext](params) : getICONS().file;
};
